import axios from 'axios';

// 生成PDF异步任务
export const exportPdfAPI = async (fileId, fName, userInfo, handleLogOut, message) => {
    return axios({
        url: `${process.env.VUE_APP_NEW_STREAM_DOWNLOAD}/stream/api/public/export/create/${fileId}`,
        method: 'POST',
        headers: {
            DeviceType: '3',
            fileId: fileId,
            token: userInfo.token,
            userId: userInfo.userId,
            spaceId: userInfo.spaceId,
            deviceId: userInfo.deviceId
        },
        data: {
            exportFormat: 'PDF'
        },
        withCredentials: true // 添加 withCredentials 选项
    });
};

// fileSocket接受推送后下载PDF
export const downloadPDFAPI = async (fileId, downloadId, fName, userInfo, handleLogOut, message) => {
    return axios({
        url: `${process.env.VUE_APP_NEW_STREAM_DOWNLOAD}/stream/api/public/export/pdf/download/${downloadId}`,
        method: 'GET',
        headers: {
            fileId: fileId,
            token: userInfo.token,
            userId: userInfo.userId,
            spaceId: userInfo.spaceId,
            deviceId: userInfo.deviceId
        },
        responseType: 'blob',
        withCredentials: true // 添加 withCredentials 选项
    }).then(response => {
        // 处理返回的文件流
        const blob = response.data;
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        // 确保文件名以 .pdf 结尾
        let fileName = fName || '导出文件';
        if (!fileName.endsWith('.pdf')) {
            fileName += '.pdf';
        }
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        window.setTimeout(function () {
            URL.revokeObjectURL(blob);
            document.body.removeChild(link);
        }, 0);
        message.success('文件生成成功');
    }).catch((err) => {
        if (err.response.status === 401) {
            handleLogOut()
            return
        }
        console.log(err, 'err')
        message.error('文件生成失败')
    })
};

export const exportHTMLAPI = async (data, handleLogOut) => {
    const { message } = data
    try {
        const res = await axios({
            url: `${process.env.VUE_APP_CLOUD_BFF}/wiki/export/html`,
            method: 'POST',
            data,
            withCredentials: true // 添加 withCredentials 选项
        })
        if (res.data.code === 200) {
            return res.data.data;
        }
        else {
            if (res.this.status === 401) {
                handleLogOut();
                return '';
            } else {
                return '';
            }
        }
    } catch (err) {
        return '';
        console.log(err, 'err')
    }
};
